import Flex from 'shopper/components/Flex';
import Text from 'shopper/components/Text';

import FOOTER from 'constants/footer';

const ITEMS = [FOOTER.INFO, FOOTER.ADDRESS, FOOTER.COPYRIGHT];

const FooterBottom = () => (
  <Flex
    alignItems="center"
    flexWrap="wrap"
    justifyContent="center"
    py={4}
    maxWidth={[null, null, '40rem', '48rem']}
    flexDirection={['column', null, 'row']}
    full
  >
    {ITEMS.map((item, index) => (
      <Text
        size="size3"
        textAlign={['center', null, 'left']}
        mt={index === 0 ? null : [4, null, 0]}
        key={item}
      >
        {item}
      </Text>
    ))}
  </Flex>
);

export default FooterBottom;
